/**
 * 色（docs/31 §5「色」・§11-8）：HEX／RGB／CMYK。CMYK → RGB の式は1つ（ここだけ）。ICC は当てない（「目安」）。
 * コントラストは WCAG の式（白地で 4.5 未満は警告）
 */
export function hex2rgb(h: string): [number, number, number] {
  let s = h.replace("#", "");
  if (s.length === 3) s = s.split("").map((c) => c + c).join("");
  const n = parseInt(s || "000000", 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
export function rgb2hex(r: number, g: number, b: number): string {
  return "#" + [r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("").toUpperCase();
}
export function rgb2cmyk(r: number, g: number, b: number): [number, number, number, number] {
  const R = r / 255, G = g / 255, B = b / 255;
  const k = 1 - Math.max(R, G, B);
  if (k >= 1) return [0, 0, 0, 100];
  return [(1 - R - k) / (1 - k), (1 - G - k) / (1 - k), (1 - B - k) / (1 - k), k].map((v) => Math.round(v * 100)) as [number, number, number, number];
}
export function cmyk2rgb(c: number, m: number, y: number, k: number): [number, number, number] {
  const C = c / 100, M = m / 100, Y = y / 100, K = k / 100;
  return [255 * (1 - C) * (1 - K), 255 * (1 - M) * (1 - K), 255 * (1 - Y) * (1 - K)];
}
function lum(h: string): number {
  const [r, g, b] = hex2rgb(h).map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export function contrast(a: string, b: string): number {
  const l1 = lum(a), l2 = lum(b);
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
}
/** 現場力の色（docs/10）。パレットの1段目 */
export const PAPER_PALETTE: ReadonlyArray<{ n: string; c: string }> = [
  { n: "墨", c: "#1A1A18" }, { n: "薄墨", c: "#55534C" }, { n: "藍", c: "#123C63" }, { n: "朱", c: "#9E2718" },
  { n: "罫線・薄", c: "#DCD9D1" }, { n: "罫線・中", c: "#C8C5BC" }, { n: "罫線・濃", c: "#8C8880" }, { n: "地色", c: "#EFEEE9" }, { n: "白", c: "#FFFFFF" },
];
